import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const parentingNeurosis: BlogMetaData = {
  title: '育児ノイローゼとは？症状チェックと5つの対処法【保育士解説】',
  description:
    '育児ノイローゼとは？7つの症状チェック・原因・なりやすい人の特徴を保育士がやさしく解説。モンテッソーリの視点から今日からできる5つの対処法と相談窓口も紹介します。頑張りすぎているあなたへ。',
  thumbnailUrl: '/img/blog-parenting-neurosis.webp',
  filePath: buildBlogFilePath('parenting-neurosis'),
  category: BLOG_CATEGORY.PARENTING,
};
